import { ref } from "vue";
import { defineStore, storeToRefs } from "pinia";
import CryptoJS from "crypto-js";
import axios from "axios";

import { useAuthenticationStore } from "@/stores/authentication";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "grokPatterns";

export const useGrokPatternsStore = defineStore(
  key,
  () => {
    // state

    const grokPatterns = ref(null);

    // actions

    const initialize = async () => {
      const authenticationStore = useAuthenticationStore();
      const { authentication } = storeToRefs(authenticationStore);

      grokPatterns.value = null;

      const headers = {
        Authorization: `Bearer ${authentication.value}`,
      };

      await axios
        .get("grok-patterns", { headers })
        .then(({ data }) => {
          grokPatterns.value = [];
          if (data.success && data.grok_patterns !== null) {
            grokPatterns.value = data.grok_patterns;
          }
        })
        .catch(() => {});
    };

    const set = (value) => {
      grokPatterns.value = value;
    };

    const unset = () => {
      grokPatterns.value = null;
    };

    return {
      grokPatterns,
      initialize,
      set,
      unset,
    };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
